import { createSlice } from "@reduxjs/toolkit";
import { tareaEnviadaParaAnalizar } from "../js/actions";
import { EEstadoTareaOperacion } from "domain/types";

const tareaTelefonoSlice = createSlice({
  name: "tareaTelefono",
  initialState: { submitIsLoading: false },
  reducers: {
    submitTareaTelefonoInited: (state) => {
      state.submitIsLoading = true;
    },
    submitTareaTelefonoCompleted: (state) => {
      state.submitIsLoading = false;
    },
    submitTareaTelefonoFailed: (state) => {
      state.submitIsLoading = false;
    },
  },
});

export const {
  submitTareaTelefonoInited,
  submitTareaTelefonoCompleted,
  submitTareaTelefonoFailed,
} = tareaTelefonoSlice.actions;

export const submitTareaTelefono = (
  solicitudId,
  tarea,
  telefonos,
  comentario,
) => {
  return async (dispatch, getState, services) => {
    try {
      let tareaUpdated = JSON.parse(JSON.stringify(tarea));
      let dataObj = "";
      let data = tareaUpdated.data;
      if (telefonos.length > 0) {
        if (tareaUpdated.data) {
          dataObj = JSON.parse(tareaUpdated.data);
          let newDataObj = { Telefonos: dataObj.Telefonos.concat(telefonos) };
          data = JSON.stringify(newDataObj);
        } else {
          data = JSON.stringify({ Telefonos: telefonos });
        }
      }

      const request = {
        Comentario: comentario,
        Telefonos: telefonos,
        data: data,
        solicitudId: solicitudId,
        sequence: tarea.sequence,
      };

      tareaUpdated.data = data;
      //Actualizo el contenido de la tarea
      if (comentario) {
        tareaUpdated.log.push({ comentario: comentario, usrExterno: true });
      }
      tareaUpdated.estado = EEstadoTareaOperacion.Para_Analizar;

      dispatch(submitTareaTelefonoInited());
      await services.api.postTareaTelefono(solicitudId, request);

      dispatch(tareaEnviadaParaAnalizar(tareaUpdated));
      dispatch(submitTareaTelefonoCompleted());
    } catch (error) {
      console.error(error);
      dispatch(submitTareaTelefonoFailed(error));
    }
  };
};

export default tareaTelefonoSlice.reducer;
